// HubSpot custom event names emitted from the frontend — the backend-dispatched set
// lives in App\Enum\HubSpotCustomEventName (src/Enum/HubSpotCustomEventName.php).
// license_activity exists in both: the backend dispatches it via LicenseActivityTracker,
// the frontend emits it through the generic intent endpoint.
export enum HubSpotCustomEventName {
    LicenseActivity = 'license_activity',
}
